<template>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <card class="custom-shadow-card-header">
        <div class="row tac">
          <div class="col-sm-6 col-md-3">
            <label for="">{{ $t('common_words.position_ubication') }}: </label>
            <br />
            <el-select
              clearable
              filterable
              class="select-default mb-3 shadow-sm"
              :placeholder="`${$t('common_words.select')}...`"
              v-model="idStation"
              @change="handleView()"
            >
              <el-option
                class="select-default"
                :label="$t('common_words.actual_position')"
                :value="0"
              >
              </el-option>
              <el-option
                class="select-default"
                v-for="(station, index) in stations"
                :key="index"
                :label="station.name"
                :value="station.id"
              >
              </el-option>
            </el-select>
            <div
              class="text-center"
              v-if="data.current && Object.keys(data).length > 0"
            >
              <img
                alt=""
                style="width: 75px"
                v-bind:src="`/static/img/iconos/${data.current.pictocode.icon}.svg`"
              />
              <br />
              <p style="font-family: 'Open Sans', sans-serif">
                {{ data.current.pictocode.name }}
              </p>
            </div>
            <div class="text-center">
              <p
                class="text-muted"
                style="
                  font-size: 20px;
                  font-family: 'Open Sans', sans-serif;
                  font-weight: bold;
                "
              >
                {{ currentTime }}
              </p>
            </div>
          </div>
          <div
            class="col-sm-6 col-md-9"
            v-if="data.current && Object.keys(data).length > 0"
          >
            <div class="row">
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/temperatura.svg" />
                <span>
                  {{
                    data.current.temperature == '-'
                      ? '---'
                      : roundNumber(data.current.temperature, 1)
                  }}
                  {{ data.current.temperature == '-' ? '' : ' &deg;C' }}
                </span>
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.temperature') }}</strong></span
                >
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/humedad.svg" />
                <span>
                  {{
                    data.current.relativehumidity == '-'
                      ? '---'
                      : roundNumber(data.current.relativehumidity, 2)
                  }}
                  {{ data.current.relativehumidity == '-' ? '' : ' %' }}
                </span>
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.humidity') }}</strong></span
                >
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/rain.svg" />
                <span style="margin-left: 10px">
                  {{
                    data.current.precipitation == '-'
                      ? '---'
                      : roundNumber(data.current.precipitation, 2)
                  }}
                  {{ data.current.precipitation == '-' ? '' : ' mm/h' }}
                </span>
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.precipitation') }}</strong></span
                >
              </div>
              <div
                class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
              >
                <img alt="" src="/static/img/iconos/lluvia.svg" />
                <span>
                  {{
                    data.current.precipitation_probability == '-'
                      ? '---'
                      : roundNumber(data.current.precipitation_probability, 2)
                  }}
                  {{
                    data.current.precipitation_probability == '-' ? '' : ' %'
                  }}
                </span>
                <br />
                <span class="text-muted"
                  ><strong>{{ $t('climate.rain_probability') }}</strong></span
                >
              </div>
            </div>
            <hr />
            <br />
            <div class="row other-climate">
              <div
                class="col-3 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/viento.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.wind') }}:</strong> <br />
                  {{
                    data.current.windspeed == '-'
                      ? '---'
                      : roundNumber(data.current.windspeed, 2)
                  }}
                  {{ data.current.windspeed == '-' ? '' : ' Km/h' }}
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/barometro.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.pressure') }}:</strong><br />
                  {{
                    data.current.surfaceairpressure == '-'
                      ? '---'
                      : data.current.surfaceairpressure + ' mb'
                  }}
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/rocio.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.dew_point') }}</strong
                  ><br />
                  {{
                    data.current.dewPoint == '-'
                      ? '--'
                      : data.current.dewPoint + ' &deg;C'
                  }}
                </p>
              </div>
              <div
                class="col-2 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/cloudy.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.cloud') }}:</strong><br />
                  {{
                    data.current.totalcloudcover == '-'
                      ? '---'
                      : roundNumber(data.current.totalcloudcover, 2)
                  }}
                  {{ data.current.totalcloudcover == '-' ? '' : ' %' }}
                </p>
              </div>
              <div class="col-3 text-center">
                <img alt="" src="/static/img/iconos/niebla.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.visibility') }}:</strong><br />
                  {{
                    data.current.visibility == '-'
                      ? '---'
                      : roundNumber(data.current.visibility / 1000, 2)
                  }}
                  {{ data.current.visibility == '-' ? '' : ' Km' }}
                </p>
              </div>
            </div>
            <hr />
            <div class="row other-climate">
              <div
                class="col-3 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img
                  alt=""
                  src="/static/img/iconos/icono-color-poblacion.svg"
                />
                <p class="text-muted">
                  <strong>{{ $t('climate.eto') }}:</strong><br />
                  {{ data.current.ETO == '-' ? '---' : data.current.ETO }}
                  {{ data.current.ETO == '-' ? ' ' : ' mm' }}
                </p>
              </div>
              <div
                class="col-3 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img alt="" src="/static/img/iconos/pronostico.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.solar_radiation') }}:</strong><br />
                  {{
                    data.current.sensibleheatflux == '-'
                      ? '---'
                      : data.current.sensibleheatflux
                  }}
                  {{ data.current.sensibleheatflux == '-' ? ' ' : ' W/m2' }}
                </p>
              </div>
              <div
                class="col-3 text-center"
                style="border-right: 1px solid #c3c3c3"
              >
                <img
                  alt=""
                  src="/static/img/iconos/temperatura-aparente-green.svg"
                />
                <p class="text-muted">
                  <strong>{{ $t('climate.apparent_temperature') }}:</strong
                  ><br />
                  {{
                    data.current.felttemperature == '-'
                      ? '---'
                      : data.current.felttemperature
                  }}
                  {{ data.current.felttemperature == '-' ? ' ' : ' °C' }}
                </p>
              </div>
              <div class="col-3 text-center">
                <img alt="" src="/static/img/iconos/indice-UV.svg" />
                <p class="text-muted">
                  <strong>{{ $t('climate.uv_index') }}:</strong><br />
                  {{
                    data.current.uvindex == '-' ? '---' : data.current.uvindex
                  }}
                  {{ data.current.uvindex == '-' ? ' ' : ' UV' }}
                </p>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_assigned_space') }}
            </h5>
          </div>
        </div>
      </card>

      <div class="row">
        <div class="col-12 map-climate" style="margin-bottom: 30px !important">
          <div ref="map" class="map" v-if="renderComponent"></div>
          <div
            id="toolbarDiv"
            class="esri-component esri-widget"
            v-if="renderComponent"
          >
            <button
              id="distance"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
              style="margin-bottom: 10px"
              :title="$t('common_words.distance_measurement_tool')"
            ></button>
            <button
              id="area"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
              style="margin-bottom: 10px"
              :title="$t('common_words.area_measurement_tool')"
            ></button>
            <button
              id="clear"
              class="action-button esri-widget--button esri-interactive esri-icon-trash"
              style="margin-bottom: 10px"
              :title="$t('common_words.clear_measurement')"
            ></button>
          </div>
        </div>
      </div>
      <card class="custom-shadow-card-header" v-if="data.current">
        <div class="row">
          <div class="col-12">
            <span class="text-muted">{{
              $t('climate.weather_forecast_example')
            }}</span>
            <hr />
            <vue-tabs @tab-change="handleTabChange">
              <v-tab
                v-for="(day, index) in data.forecast.fullWeek"
                :key="index"
                :title="day"
              >
                <br />
                <div class="row">
                  <div class="text-center col-xs-12 col-sm-3 col-md-2">
                    <img
                      alt=""
                      style="width: 75px"
                      v-bind:src="`/static/img/iconos/${data.forecast.forecast[index].pictocode.icon}.svg`"
                    />
                    <br />
                    <p style="font-family: 'Open Sans', sans-serif">
                      {{ data.forecast.forecast[index].pictocode.name }}
                    </p>
                  </div>
                  <div class="col-xs-12 col-sm-9 col-md-10">
                    <div class="row">
                      <div
                        class="col-12"
                        v-if="
                          data.forecast && Object.keys(data.forecast).length > 0
                        "
                      >
                        <div class="row">
                          <div
                            class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                          >
                            <img
                              alt=""
                              src="/static/img/iconos/temperatura.svg"
                            />
                            <span>
                              {{
                                data.forecast.forecast[index]
                                  .temperature_mean == '-'
                                  ? '---'
                                  : roundNumber(
                                      data.forecast.forecast[index]
                                        .temperature_mean,
                                      1
                                    )
                              }}
                              {{
                                data.forecast.forecast[index]
                                  .temperature_mean == '-'
                                  ? ''
                                  : ' &deg;C'
                              }}
                            </span>
                            <br />
                            <span class="text-muted"
                              ><strong>{{
                                $t('climate.temperature')
                              }}</strong></span
                            >
                          </div>
                          <div
                            class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                          >
                            <img alt="" src="/static/img/iconos/humedad.svg" />
                            <span>
                              {{
                                data.forecast.forecast[index]
                                  .relativehumidity_mean == '-'
                                  ? '---'
                                  : roundNumber(
                                      data.forecast.forecast[index]
                                        .relativehumidity_mean,
                                      2
                                    )
                              }}
                              {{
                                data.forecast.forecast[index]
                                  .relativehumidity_mean == '-'
                                  ? ''
                                  : ' %'
                              }}
                            </span>
                            <br />
                            <span class="text-muted"
                              ><strong>{{
                                $t('climate.humidity')
                              }}</strong></span
                            >
                          </div>
                          <div
                            class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                          >
                            <img alt="" src="/static/img/iconos/rain.svg" />
                            <span style="margin-left: 10px">
                              {{
                                data.forecast.forecast[index].precipitation ==
                                '-'
                                  ? '---'
                                  : roundNumber(
                                      data.forecast.forecast[index]
                                        .precipitation,
                                      2
                                    )
                              }}
                              {{
                                data.forecast.forecast[index].precipitation ==
                                '-'
                                  ? ''
                                  : ' mm/h'
                              }}
                            </span>
                            <br />
                            <span class="text-muted"
                              ><strong>{{
                                $t('climate.precipitation')
                              }}</strong></span
                            >
                          </div>
                          <div
                            class="text-center col-xs-12 col-sm-3 col-md-3 icon-climate-actually"
                          >
                            <img alt="" src="/static/img/iconos/lluvia.svg" />
                            <span>
                              {{
                                data.forecast.forecast[index]
                                  .precipitation_probability == '-'
                                  ? '---'
                                  : roundNumber(
                                      data.forecast.forecast[index]
                                        .precipitation_probability,
                                      2
                                    )
                              }}
                              {{
                                data.forecast.forecast[index]
                                  .precipitation_probability == '-'
                                  ? ''
                                  : ' %'
                              }}
                            </span>
                            <br />
                            <span class="text-muted"
                              ><strong>{{
                                $t('climate.rain_probability')
                              }}</strong></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <br />
                    <div class="row other-climate">
                      <div
                        class="col-3 text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img alt="" src="/static/img/iconos/viento.svg" />
                        <p class="text-muted">
                          <strong>{{ $t('climate.wind') }}:</strong> <br />
                          {{
                            data.forecast.forecast[index].windspeed_mean == '-'
                              ? '---'
                              : roundNumber(
                                  data.forecast.forecast[index].windspeed_mean,
                                  2
                                )
                          }}
                          {{
                            data.forecast.forecast[index].windspeed_mean == '-'
                              ? ''
                              : ' Km/h'
                          }}
                        </p>
                      </div>
                      <div
                        class="col-2 text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img alt="" src="/static/img/iconos/barometro.svg" />
                        <p class="text-muted">
                          <strong>{{ $t('climate.pressure') }}:</strong><br />
                          {{
                            data.forecast.forecast[index]
                              .surfaceairpressure_mean == '-'
                              ? '---'
                              : data.forecast.forecast[index]
                                  .surfaceairpressure_mean + ' mb'
                          }}
                        </p>
                      </div>
                      <div
                        class="col-2 text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img alt="" src="/static/img/iconos/rocio.svg" />
                        <p class="text-muted">
                          <strong>{{ $t('climate.dew_point') }}:</strong><br />
                          {{
                            data.forecast.forecast[index].dewPoint == '-'
                              ? '---'
                              : data.forecast.forecast[index].dewPoint +
                                ' &deg;C'
                          }}
                        </p>
                      </div>
                      <div
                        class="col-2 text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img alt="" src="/static/img/iconos/cloudy.svg" />
                        <p class="text-muted">
                          <strong>{{ $t('climate.cloud') }}:</strong><br />
                          {{
                            data.forecast.forecast[index]
                              .totalcloudcover_mean == '-'
                              ? '---'
                              : data.forecast.forecast[index]
                                  .totalcloudcover_mean + ' %'
                          }}
                        </p>
                      </div>
                      <div class="col-3 text-center">
                        <img alt="" src="/static/img/iconos/niebla.svg" />
                        <p class="text-muted">
                          <strong>{{ $t('climate.visibility') }}:</strong><br />
                          {{
                            data.forecast.forecast[index].visibility_mean == '-'
                              ? '---'
                              : roundNumber(
                                  data.forecast.forecast[index]
                                    .visibility_mean / 1000,
                                  2
                                )
                          }}
                          {{
                            data.forecast.forecast[index].visibility_mean == '-'
                              ? ''
                              : ' Km'
                          }}
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div class="row other-climate">
                      <div
                        class="col-3 text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img
                          alt=""
                          src="/static/img/iconos/icono-color-poblacion.svg"
                        />
                        <p class="text-muted">
                          <strong>{{ $t('climate.eto') }}:</strong><br />
                          {{
                            data.forecast.forecast[index].ETO == '-'
                              ? '---'
                              : data.forecast.forecast[index].ETO + ' mm'
                          }}
                        </p>
                      </div>
                      <div
                        class="col-3 text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img alt="" src="/static/img/iconos/pronostico.svg" />
                        <p class="text-muted">
                          <strong>{{ $t('climate.solar_radiation') }}:</strong
                          ><br />
                          {{
                            data.forecast.forecast[index].sensibleheatflux ==
                            '-'
                              ? '---'
                              : data.forecast.forecast[index].sensibleheatflux +
                                ' W/m2'
                          }}
                        </p>
                      </div>
                      <div
                        class="col-3 text-center"
                        style="border-right: 1px solid #c3c3c3"
                      >
                        <img
                          alt=""
                          src="/static/img/iconos/temperatura-aparente-green.svg"
                        />
                        <p class="text-muted">
                          <strong
                            >{{ $t('climate.apparent_temperature') }}:</strong
                          ><br />
                          {{
                            data.forecast.forecast[index].felttemperature == '-'
                              ? '---'
                              : data.forecast.forecast[index].felttemperature
                          }}
                          {{
                            data.forecast.forecast[index].felttemperature == '-'
                              ? ' '
                              : ' °C'
                          }}
                        </p>
                      </div>
                      <div class="col-3 text-center">
                        <img alt="" src="/static/img/iconos/indice-UV.svg" />
                        <p class="text-muted">
                          <strong>{{ $t('climate.uv_index') }}:</strong><br />
                          {{
                            data.forecast.forecast[index].uvindex == '-'
                              ? '---'
                              : data.forecast.forecast[index].uvindex
                          }}
                          {{
                            data.forecast.forecast[index].uvindex == '-'
                              ? ' '
                              : ' UV'
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <br />
                    <br />
                    <p
                      class="text-center text-muted"
                      style="font-family: 'Open Sans', sans-serif"
                    >
                      {{ $t('climate.min_temperature') }}
                      {{
                        data.forecast.forecast[index].temperature_min == '-'
                          ? 0
                          : data.forecast.forecast[index].temperature_min
                      }}
                      {{ $t('climate.max_temperature') }}
                      {{
                        data.forecast.forecast[index].temperature_max == '-'
                          ? 0
                          : data.forecast.forecast[index].temperature_max
                      }}
                    </p>
                    <el-slider
                      class="slider-info"
                      style="margin: 0 90px"
                      v-model="rangeSlider"
                      :max="40"
                      :min="10"
                      :marks="marks"
                      :range="true"
                      :disabled="false"
                    >
                    </el-slider>
                    <br />
                  </div>
                </div>
                <br />
                <br />
              </v-tab>
            </vue-tabs>
          </div>
        </div>
      </card>

      <card class="custom-shadow-card-header">
        <span
          v-if="
            Object.keys(chartOptions).length > 0 &&
            Object.values(chartOptions.xAxis.categories).length
          "
        >
          <div class="row">
            <div class="col-12">
              <highcharts :options="chartOptions"></highcharts>
            </div>
          </div>
        </span>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_assigned_graph') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Menu, MenuItem, Slider } from 'element-ui';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinCharts from 'src/util/mixinCharts';
import MixinNumbers from 'src/util/mixinNumbers';
import SweetAlert from 'src/class/Alerts';
import VueTabs from 'vue-nav-tabs';
import axios from 'axios';
import moment from 'moment';
import { Chart } from 'highcharts-vue';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import mixinLocation from 'src/util/mixinLocation';
import i18n from 'src/i18n';

export default {
  components: {
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [VueTabs.name]: VueTabs,
    [Slider.name]: Slider,
    highcharts: Chart,
  },

  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      renderComponent: true,
      stations: [],
      currently: [],
      data: {},
      currentTime: moment().format('hh:mm:ss'),
      currentDate: moment().format('YYYY-MM-DD'),
      currentTime24: moment().format('HH:mm:ss'),
      chartOptions: {},
      rangeSlider: null,
      idStation: 0,
      marks: {
        10: '10°C',
        20: '20°C',
        30: '30°C',
        40: '40°C',
        50: '50°C',
      },
      map: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinCharts,
    MixinNumbers,
    MixinArcgisMap,
    mixinMasters,
    MixinMenu,
    mixinLocation,
  ],

  watch: {
    '$i18n.locale': 'getChartLabels',
  },

  methods: {
    handleTabChange(tabIndex, newTab, oldTab) {
      this.handleRange(
        this.data.forecast.forecast[tabIndex].temperature_min,
        this.data.forecast.forecast[tabIndex].temperature_max
      );
    },

    handleRange(min, max) {
      this.rangeSlider = [min, max];
    },

    handleView() {
      this.getDataClimateForecast(this.idStation);
    },

    getChartLabels() {
      if (this.data) {
        this.chartOptions = this.spline(
          i18n.t('climate.weather_forecast'),
          i18n.t('common_words.actual_position'),
          this.data.forecast.fullWeek,
          this.data.serie_bar
        );
      }
    },

    getDataClimateForecast(idStation) {
      if (this.isClimateForecast()) {
        this.showHideLoading(true);
        if (idStation == 0) {
          this.getPosition().then(() => {
            axios
              .get(
                `/auth/climates/climateforecastdashboardmb/${this.center.lat},${this.center.lng}/${this.currentDate}/${this.currentTime24}`
              )
              .then((response) => {
                this.data = response.data;

                this.getChartLabels();

                this.handleRange(
                  this.data.forecast.forecast[0].temperature_min,
                  this.data.forecast.forecast[0].temperature_max
                );
                this.loadMap();
                this.showHideLoading();
              })
              .catch((error) => {
                this.showHideLoading();
                SweetAlert.warning(error.response.data.message);
              });
          });
        } else {
          axios
            .get(
              `/auth/climates/climateforecastdashboardmb/${idStation}/${this.currentDate}/${this.currentTime24}`
            )
            .then((response) => {
              this.data = response.data;

              this.center.lat = this.data.lat
                ? parseInt(this.data.lat)
                : this.center.lat;
              this.center.lng = this.data.lon
                ? parseInt(this.data.lon)
                : this.center.lng;

              this.loadMap();

              let nameStation = '';
              for (let index = 0; index < this.stations.length; index++) {
                const element = this.stations[index];
                if (element.id == this.idStation) {
                  nameStation = element.name;
                  break;
                }
              }
              this.getChartLabels();

              this.handleRange(
                this.data.forecast.forecast[0].temperature_min,
                this.data.forecast.forecast[0].temperature_max
              );
              this.showHideLoading();
            })
            .catch((error) => {
              console.log(error);
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });
        }
      }
    },

    loadMap() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadBaseMap(null, true);

        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 7%;right: 30px';
        }, 10);
      });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('devices/stations/only/all')
        .then((response) => {
          this.stations = response.data.data;
          this.getDataClimateForecast(0, 'Pos. Actual');
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('climates');
  },

  destroyed() {
    this.deselectedItemOnMenu('climates');
  },
};
</script>
<style></style>
